import * as React from "react";
import FormSwitch from "./FormSwitch";
import FormBuildCV from "./FormBuildCV";
import FormOwnCV from "./FormOwnCV";
import FormFastCV from "./FormFastCV";

export class FormContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hasData: false,
            WithCVTitle: null,
            WithCVContent: null,
            WithoutCVContent: null,
            WithoutCVTitle: null,
            customBuildSelected: null,
            FastCVContent: null,
            FastCVTitle: null,
            FastCVSubTitle: null,
            fastCVSelected: null,
            WithCVEnabled: null,
            WithoutCVEnabled: null,
            FastCVEnabled: null,
            RecaptchaKey: null,
            RequiredFieldHint: null,
            ValidationHash: null,
            SessionID: null,
        }
        this.setBuildCV = this.setBuildCV.bind(this);
        this.setOwnCV = this.setOwnCV.bind(this);
        this.setFastCV = this.setFastCV.bind(this);
    }

    componentDidMount(){
        fetch(this.props.SwitchDataLink).then(response => {
            return response.json();
        }).then(json => {
            this.setState({
                hasData: true,
                WithCVTitle: json.WithCVTitle,
                WithCVContent: json.WithCVContent,
                WithoutCVContent: json.WithoutCVContent,
                WithoutCVTitle: json.WithoutCVTitle,
                FastCVContent: json.FastCVContent,
                FastCVTitle: json.FastCVTitle,
                FastCVSubTitle: json.FastCVSubTitle,
                WithCVEnabled: json.WithCVEnabled,
                WithoutCVEnabled: json.WithoutCVEnabled,
                FastCVEnabled: json.FastCVEnabled,
                RecaptchaKey: json.RecaptchaKey,
                RequiredFieldHint: json.RequiredFieldHint,
                ValidationHash: json.ValidationHash,
                SessionID: (+new Date).toString(36) + '_' + json.ValidationHash,
            })
        })
    }

    setBuildCV(){
        this.setState({
            customBuildSelected: true,
        })
    }

    setOwnCV(){
        this.setState({
            customBuildSelected: false,
        })
    }

    setFastCV(){
        this.setState({
            customBuildSelected: false,
            fastCVSelected: true,
        })
    }

    renderForm(){
        if(this.state.customBuildSelected === null) {
            return <FormSwitch
                WithCVTitle={this.state.WithCVTitle}
                WithCVContent={this.state.WithCVContent}
                WithoutCVTitle={this.state.WithoutCVTitle}
                WithoutCVContent={this.state.WithoutCVContent}
                FastCVTitle={this.state.FastCVTitle}
                FastCVSubTitle={this.state.FastCVSubTitle}
                FastCVContent={this.state.FastCVContent}
                WithCVEnabled={this.state.WithCVEnabled}
                WithoutCVEnabled={this.state.WithoutCVEnabled}
                FastCVEnabled={this.state.FastCVEnabled}
                setBuildCV={this.setBuildCV}
                setOwnCV={this.setOwnCV}
                setFastCV={this.setFastCV}
            />
        }
        if(this.state.customBuildSelected){
            return <FormBuildCV
                DataLink={this.props.BuildCVApplyDataLink}
                handleForm={this.props.handleCVForm}
                RequiredFieldHint={this.state.RequiredFieldHint}
                ValidationHash={this.state.ValidationHash}
                SessionID={this.state.SessionID}
                trackInputLink={this.props.trackInputLink}
                trackSubmitLink={this.props.trackSubmitLink}
            />
        } else if(this.state.fastCVSelected){
            return <FormFastCV
                DataLink={this.props.FastCVApplyFormJSONData}
                handleForm={this.props.handleCVForm}
                RequiredFieldHint={this.state.RequiredFieldHint}
                ValidationHash={this.state.ValidationHash}
                SessionID={this.state.SessionID}
                trackInputLink={this.props.trackInputLink}
                trackSubmitLink={this.props.trackSubmitLink}
            />
        } else {
            return <FormOwnCV
                DataLink={this.props.OwnCVApplyDataLink}
                handleForm={this.props.handleCVForm}
                RequiredFieldHint={this.state.RequiredFieldHint}
                ValidationHash={this.state.ValidationHash}
                SessionID={this.state.SessionID}
                trackInputLink={this.props.trackInputLink}
                trackSubmitLink={this.props.trackSubmitLink}
            />
        }
    }

    render(){
        if(!this.state.hasData){
            return null;
        }
        return (
            <div className="">
                {this.renderForm()}
            </div>
        )
    }
}

export default FormContainer;
